import React, { useState } from "react";
import { TextField, Button } from "@mui/material";
import { Save } from "@mui/icons-material";

const EditForm = ({ initialData, onUpdate }) => {
  const [school_name, setSchoolName] = useState(initialData.school_name);
  const [district, setDistrict] = useState(initialData.district);
  const [school_id, setSchoolId] = useState(initialData.school_id);

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updatedData = {
      id: initialData.id,
      school_name: school_name,
      district: district,
      school_id: school_id,
    };
    onUpdate(updatedData);
  };

  return (
    <form onSubmit={handleFormSubmit}>
      <TextField
        label="School Name"
        value={school_name}
        onChange={(e) => setSchoolName(e.target.value)}
        fullWidth
        required
        margin="normal"
      />
      <TextField
        label="District Name"
        value={district}
        onChange={(e) => setDistrict(e.target.value)}
        fullWidth
        required
        margin="normal"
      />
      <TextField
        label="School Id"
        value={school_id}
        onChange={(e) => setSchoolId(e.target.value)}
        fullWidth
        required
        margin="normal"
      />

      <Button
        type="submit"
        variant="outlined"
        color="success"
        endIcon={<Save />}
      >
        Update
      </Button>
    </form>
  );
};

export default EditForm;
